<div class="clubs-page">
  <div class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">ReBall</h1>
      <p class="hero-subtitle">Find and book padel courts near you</p>
      <div class="hero-actions" *ngIf="!isLoggedIn">
        <button class="hero-btn primary" (click)="goToLogin()">
          <span class="btn-icon"
            ><lucide-icon name="user" [size]="18"></lucide-icon
          ></span>
          <span class="btn-text">Log In</span>
        </button>
        <button class="hero-btn secondary" (click)="goToRegister()">
          <span class="btn-icon"
            ><lucide-icon name="sparkles" [size]="18"></lucide-icon
          ></span>
          <span class="btn-text">Create Account</span>
        </button>
      </div>
    </div>
  </div>

  <div class="clubs-content">
    <div class="loading-overlay" *ngIf="loading">
      <div class="loading-spinner"></div>
      <p class="loading-text">Loading clubs...</p>
    </div>

    <div class="filter-section">
      <h3 class="section-title">Court Type</h3>
      <div class="filter-tabs">
        <button
          class="filter-tab"
          [class.active]="filterType === 'all'"
          (click)="setFilterType('all')"
        >
          <span class="tab-icon"
            ><lucide-icon name="landmark" [size]="16"></lucide-icon
          ></span>
          <span class="tab-text">All</span>
        </button>
        <button
          class="filter-tab"
          [class.active]="filterType === 'indoor'"
          (click)="setFilterType('indoor')"
        >
          <span class="tab-icon"
            ><lucide-icon name="home" [size]="16"></lucide-icon
          ></span>
          <span class="tab-text">Indoor</span>
        </button>
        <button
          class="filter-tab"
          [class.active]="filterType === 'outdoor'"
          (click)="setFilterType('outdoor')"
        >
          <span class="tab-icon"
            ><lucide-icon name="sun" [size]="16"></lucide-icon
          ></span>
          <span class="tab-text">Outdoor</span>
        </button>
      </div>
    </div>

    <div class="clubs-section">
      <h3 class="section-title">Available Clubs</h3>
      <div class="clubs-grid">
        <div
          *ngFor="let club of filteredClubs"
          class="club-card"
          (click)="selectClub(club)"
        >
          <div class="club-image">
            <img
              [src]="club.img_path"
              [alt]="club.name"
              (error)="handleImageError($event, club)"
              [style.display]="
                club.img_path && !club.imageError ? 'block' : 'none'
              "
            />
            <div
              class="club-placeholder"
              *ngIf="!club.img_path || club.imageError"
            >
              <div class="placeholder-icon">
                <lucide-icon name="landmark" [size]="32"></lucide-icon>
              </div>
              <div class="placeholder-text">Image Coming Soon</div>
            </div>
            <div class="club-overlay">
              <div class="club-name">{{ club.name }}</div>
            </div>
          </div>
          <div class="club-info">
            <div class="club-details">
              <div
                class="detail-item"
                (click)="openMaps(club.location, $event)"
              >
                <span class="detail-icon"
                  ><lucide-icon name="map-pin" [size]="14"></lucide-icon
                ></span>
                <span class="detail-text location-link">{{
                  club.location
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-icon"
                  ><lucide-icon name="circle-dot" [size]="14"></lucide-icon
                ></span>
                <span class="detail-text"
                  >{{ club.number_of_courts }} courts</span
                >
              </div>
              <div class="detail-item">
                <span class="detail-icon"
                  ><lucide-icon name="clock" [size]="14"></lucide-icon
                ></span>
                <span class="detail-text">{{
                  getClubWorkingHoursDisplay(club)
                }}</span>
              </div>
              <div class="detail-item" *ngIf="getClubMinPrice(club)">
                <span class="detail-icon"
                  ><lucide-icon name="hash" [size]="14"></lucide-icon
                ></span>
                <span class="detail-text"
                  >From {{ getClubMinPrice(club) }} RSD/h</span
                >
              </div>
            </div>
            <button class="book-btn" *ngIf="!isLoggedIn">
              <span class="btn-text">View & Book</span>
              <span class="btn-arrow">→</span>
            </button>
            <button class="book-btn logged-in" *ngIf="isLoggedIn">
              <span class="btn-text">Book Court</span>
              <span class="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="cta-section" *ngIf="!isLoggedIn">
      <div class="cta-card">
        <div class="cta-icon">
          <img
            class="cta-logo"
            src="assets/reball/reball logo no bg.png"
            alt="ReBall"
          />
        </div>
        <h3 class="cta-title">Ready to Play?</h3>
        <p class="cta-text">
          Create a free account to book courts, track your matches, and compete
          in rankings.
        </p>
        <div class="cta-actions">
          <button class="cta-btn primary" (click)="goToRegister()">
            <span class="btn-text">Create Free Account</span>
          </button>
          <button class="cta-btn secondary" (click)="goToRankings()">
            <span class="btn-text">View Rankings</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
